/**
 * 앱 안에서의 '뒤로' — 상단 [<] 와 휴대폰 뒤로 가기(Flutter BACK_BUTTON)가 같이 쓴다(2026-11-02).
 *
 * 바로 앞 기록이 앱 화면일 때만 기록을 따라간다. vue-router 가 앞 화면을 history.state.back 에 적어 두는데,
 * 비어 있으면 앞이 앱 밖이다 - 본인인증은 같은 창에서 NICE 로 나갔다 돌아오므로 그 화면들이 기록에 남고,
 * 따라가면 NICE 의 '세션이 종료되었습니다' 가 나온다. 그때는 기록 대신 홈으로 간다.
 *
 * (기록을 되감아 NICE 화면을 걷어내는 방식은 접었다 - 브라우저가 기록을 50개까지만 두어, 길게 쓴 탭에서는
 * 되감을 칸 수가 어긋나 NICE 화면 한가운데로 떨어질 수 있다.)
 */
const HOME = '/home'

/** @returns {boolean} 처리했으면 true. 이미 홈이라 더 갈 곳이 없으면 false(앱이 종료를 묻는다) */
export function goBackInApp(router) {
  if (typeof window !== 'undefined' && window.history.state && window.history.state.back) {
    router.back()
    return true
  }
  if (router.currentRoute.value.path !== HOME) {
    router.replace(HOME)
    return true
  }
  return false
}
